// extracted by mini-css-extract-plugin
export default {"root":"FormReadOnlyInput_root__Pl3XK"};